export enum FieldErrorCodeEnum {
  REQUIRED = "REQUIRED",
  INVALID_TYPE = "INVALID_TYPE",
  TOO_SHORT = "TOO_SHORT",
  TOO_LONG = "TOO_LONG",
  INVALID_FORMAT = "INVALID_FORMAT",
  INVALID = "INVALID",
}
